import React, { useState } from 'react'
import { Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap'
import classnames from 'classnames'
import { useTranslation } from 'react-i18next'
import Head from '../../layout/head/Head'
import AdminActivities from './AdminActivities'
import AdminUsers from './AdminUsers'
import AdminPackages from './AdminPackages'
import AdminChangePassword from './AdminChangePassword'

const AdminDashboard = ({ userRoles }) => {
  const getDefaultTab = () => {
    if (userRoles.ADMIN) return '1'
    if (userRoles.ADMIN_PERSONNEL_USERS) return '2'
    if (userRoles.ADMIN_PERSONNEL_PACKAGES) return '4'
    return '1'
  }
  const [activeTab, setActiveTab] = useState(getDefaultTab())
  const { t } = useTranslation()

  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab)
  }

  return (
    <React.Fragment>
      <Head title={t('admin.title')}/>
      <div className="nk-content-body">
        <div className="nk-block">
          <Nav tabs>
            {userRoles.ADMIN && (
              <NavItem>
                <NavLink
                  tag="a"
                  href="#tab"
                  className={classnames({ active: activeTab === '1' })}
                  onClick={(ev) => {
                    ev.preventDefault()
                    toggle('1')
                  }}
                >
                  {t('admin.tabs.activities')}
                </NavLink>
              </NavItem>
            )}
            {userRoles.ADMIN_PERSONNEL_USERS && (
              <NavItem>
                <NavLink
                  tag="a"
                  href="#tab"
                  className={classnames({ active: activeTab === '2' })}
                  onClick={(ev) => {
                    ev.preventDefault()
                    toggle('2')
                  }}
                >
                  {t('admin.tabs.users')}
                </NavLink>
              </NavItem>
            )}
            {userRoles.ADMIN_PERSONNEL_PACKAGES && (
              <NavItem>
                <NavLink
                  tag="a"
                  href="#tab"
                  className={classnames({ active: activeTab === '4' })}
                  onClick={(ev) => {
                    ev.preventDefault()
                    toggle('4')
                  }}
                >
                  {t('admin.tabs.packages', 'Paketler')}
                </NavLink>
              </NavItem>
            )}
            {userRoles.ADMIN && (
              <NavItem>
                <NavLink
                  tag="a"
                  href="#tab"
                  className={classnames({ active: activeTab === '3', disabled: true })}
                  onClick={(ev) => {
                    ev.preventDefault()
                    // toggle('3')
                  }}
                >
                  {t('admin.tabs.changePassword')}
                </NavLink>
              </NavItem>
            )}
          </Nav>
          <TabContent activeTab={activeTab} style={{ marginTop: 0 }}>
            {userRoles.ADMIN && (
              <TabPane tabId="1">
                <div className="p-4 bg-white border border-top-0 rounded-bottom">
                  <AdminActivities/>
                </div>
              </TabPane>
            )}
            {userRoles.ADMIN_PERSONNEL_USERS && (
              <TabPane tabId="2">
                <div className="p-4 bg-white border border-top-0 rounded-bottom">
                  <AdminUsers/>
                </div>
              </TabPane>
            )}
            {userRoles.ADMIN_PERSONNEL_PACKAGES && (
              <TabPane tabId="4">
                <div className="p-4 bg-white border border-top-0 rounded-bottom">
                  <AdminPackages/>
                </div>
              </TabPane>
            )}
            {userRoles.ADMIN && (
              <TabPane tabId="3">
                <div className="p-4 bg-white border border-top-0 rounded-bottom">
                  <AdminChangePassword/>
                </div>
              </TabPane>
            )}
          </TabContent>
        </div>
      </div>
    </React.Fragment>
  )
}

export default AdminDashboard
